import useViewportDimensions from '../hooks/useViewportDimensions';
import ControlBar from './ControlBar';
import Paper from 'common/Paper';
import { FunctionComponent, ReactNode, useRef } from 'react';
import { TransitionStatus, Transition } from 'react-transition-group';
import styled, { DefaultTheme } from 'styled-components';

const short = (theme: DefaultTheme) => theme.transitions.duration.standard;

const ease = (theme: DefaultTheme) => theme.transitions.easing.easeInOut;

const StyledSidePanelContainer = styled(Paper)<{
	viewportHeight: number;
	state: TransitionStatus;
}>`
	opacity: 1;
	transition: transform ${({ theme }) => `${short(theme)}ms ${ease(theme)}`},
		opacity ${({ theme }) => `${short(theme)}ms ${ease(theme)}`};
	transform: ${(p) =>
		`translateX(${
			p.state === 'entered' || p.state === 'entering'
				? -8
				: p.theme.drawerWidth * 2
		}px)`};
	position: absolute;
	width: ${(p) => `${p.theme.drawerWidth * 2}px`};
	height: ${(p) =>
		`${p.viewportHeight - p.theme.navHeight - p.theme.panelGutter}px`};
	top: ${(p) => `${p.theme.navHeight}px`};
	right: 0;
	display: flex;
	flex-direction: column;
	overflow: visible;
	z-index: ${(p) => p.theme.zIndex.controlSurface};
	border: 1px solid ${(p) => p.theme.palette.divider};
	border-right: 0;
	padding: 10px 5px 5px;
`;

interface RightDrawerProps {
	showControls: boolean;
	// zIndex: number;
	drawerOpen: boolean;
	children?: ReactNode;
}

const RightDrawer: FunctionComponent<RightDrawerProps> = ({
	showControls,
	drawerOpen,
	children,
}) => {
	// Need this ref to stop react-transition-group from trying to
	// use findDOMNode, which is deprecated and profoundly irritating.
	const transitionRef = useRef<any>();

	const { viewportHeight } = useViewportDimensions();

	return (
		<Transition in={drawerOpen} timeout={10} nodeRef={transitionRef}>
			{(state) => (
				<StyledSidePanelContainer
					ref={transitionRef}
					viewportHeight={viewportHeight}
					state={state}
					data-testid="hud-right-drawer-container"
					className="side-container"
				>
					{/* Need vertical scroll for content panel, and for some reason setting
                    overflow-y on StyledSidePanelContainer hides translated control bar, so we put
                    the scroll on an inner container instead. */}
					<div style={{ overflowY: 'auto', overflowX: 'hidden' }}>
						{showControls && <ControlBar />}
						{children}
					</div>
				</StyledSidePanelContainer>
			)}
		</Transition>
	);
};

export default RightDrawer;
